module.exports = __webpack_public_path__ + "img/app-service.3e05fcb2.svg";